import { Badge } from '@/components/ui/Badge';

export function ImChannelChatBadge({ visible }: { visible: boolean }) {
  if (!visible) return null;
  return (
    <Badge
      variant="secondary"
      className="shrink-0 px-1 py-0 text-[10px]"
      title="Messaging channel chat"
    >
      IM
    </Badge>
  );
}
